module.exports = __webpack_public_path__ + "static/media/profitcredit.2d08bd26.svg";